module.exports = __webpack_public_path__ + "static/media/star-24px.074af6c5.svg";